export default __webpack_public_path__ + "static/media/girl1.7f9d8736.svg";